<div class="relative" [ngClass]="loading ? 'b-radius-wide' : 'padding-auto b-grey'" [class.events-none]="imageError">
  <div class="am-flex-center overflow events-none">
    @if ( image   && !imageError) { <img #imageElement [src]="image" [ngClass]="loading ? 'absolute hide' : ''" (load)="imageRendered()" alt="Foto item" class="wp-attachment-item-image"/> }
    @if (!loading &&  imageError) { <img class="width-150" src="assets/images/broken-image.svg" /> }
    @if ( loading && !imageError) { <span class="am-flex width-250 height-400 loading-animate"></span> }
  </div>

  @if (!imageError && image && rendered && !loading) {
    <div class="am-flex-justify gap-m margin-auto padding-auto absolute top-0 left-0 right-0 image-controls z-1">
      <div class="am-flex gap-s">
        <button class="width-30 height-30 blue" (click)="rotateLeft($event)" >
          <span class="am-flex-center font-small-icon icon-rotate-ccw"></span>
        </button>
        <button class="width-30 height-30 blue" (click)="rotateRight($event)">
          <span class="am-flex-center font-small-icon icon-rotate-cw"></span>
        </button>
      </div>
      <div class="am-flex gap-m">
        <div class="am-flex gap-s">
          @if (validOCR && !showReset) {
            <button class="am-flex-center height-30 gap-xs green" (click)="preselectOCR.emit()">
              <span class="am-flex-center font-small-icon icon-time-tracking-add"></span>
              <span class="mobile-hide">Texterkennung nutzen</span>
            </button>
          }
          @if (showReset) {
            <button class="am-flex-center height-30 gap-xs blue" (click)="resetTimeFrames.emit()">
              <span class="am-flex-center font-small-icon icon-bin"></span>
              <span class="mobile-hide">Bericht zurücksetzen</span>
            </button>
          }
        </div>
        <div class="am-flex gap-s">
          <button class="width-30 height-30 blue" (click)="zoomInCenter($event)">
            <span class="am-flex-center font-small-icon icon-plus"></span>
          </button>
          <button class="width-30 height-30 blue" (click)="zoomOutCenter($event)">
            <span class="am-flex-center font-small-icon icon-minus"></span>
          </button>
        </div>
      </div>
    </div>
  }

  @if (backPage && !imageError && image && rendered && !loading) {
    <div class="am-flex-align gap-s font-500 margin-auto padding-auto absolute bottom-0 left-0 right-0 z-1">
      <div class="am-flex-align gap-xxs pt-xxs pb-xxs pl-xs pr-xs height-30 bg-white b-grey">
        <span class="am-flex-center font-small-icon icon-document"></span>
        <span class="font-s">2-Seiten</span>
      </div>
      <button class="width-30 height-30 font-xl" [ngClass]="active === 'frontPage' ? 'blue' : 'white'" (click)="updateView('frontPage')">1</button>
      <button class="width-30 height-30 font-xl" [ngClass]="active === 'backPage'  ? 'blue' : 'white'" (click)="updateView('backPage')" >2</button>
    </div>
  }

  <div class="absolute full-postion-auto overflow">
    <div id="ocr-table" class="absolute-full" [class.events-none]="disableOcrEvents">
      @for (meta of ocrMetaTable; track meta) {
        <div class="tooltip-hover-absolute pointer"
            [attr.data-timeFrameDate]="meta.frameDate"
            [attr.data-fieldName]="meta.metaField"
            [ngClass]="getColor(meta)"
            [style.left.px]="getOcrPosition(meta.polygon).left/ocrRatio"
            [style.top.px]="getOcrPosition(meta.polygon).top/ocrRatio"
            [style.right.px]="getOcrPosition(meta.polygon).right/ocrRatio"
            [style.bottom.px]="getOcrPosition(meta.polygon).bottom/ocrRatio">
          @if (!OCRConfident(meta)) {
            <div class="web-tooltip white" [ngStyle]="getPopupStyles()">
              <span class="tooltip-title">Systemseitig nicht eindeutig, bitte überprüfen.</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
